export { default } from './Pages.vue'
